import {
  DashboardState,
  GET_DASHBOARD,
  GET_DASHBOARD_SUCCESS,
  GET_DASHBOARD_FAILURE,
  RESET_DASHBOARD,
  DashboardActionTypes,
} from "../types/dashboardType";

const initialState: DashboardState = {
  dashboardList: null,
  dashboardSuccess: null,
  dashboardError: null,
  dashboardLoading: false,
};

export const dashboardReducer = (
  state = initialState,
  action: DashboardActionTypes
): DashboardState => {
  switch (action.type) {
    case GET_DASHBOARD: {
      return {
        ...state,
        dashboardList: [],
        dashboardError: null,
        dashboardLoading: true,
      };
    }

    case GET_DASHBOARD_SUCCESS: {
      return {
        ...state,
        dashboardList: action.payload,
        dashboardError: null,
        dashboardLoading: false,
      };
    }

    case GET_DASHBOARD_FAILURE: {
      return {
        ...state,
        dashboardError: action.payload,
        dashboardLoading: false,
      };
    }

    case RESET_DASHBOARD: {
      return {
        ...state,
        dashboardSuccess: null,
        dashboardError: null,
        dashboardLoading: false,
      };
    }

    default:
      return state;
  }
};
